export default "__VITE_ASSET__zL0Sk8ym__"